import * as yup from "yup";

export const schema = yup.object().shape({
  email: yup
    .string()
    .email("O e-mail deve ser formatado corretamente")
    .required("Preencha esse campo obrigatório."),
  areWorking: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  homeIncome: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  financial: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  howToStay: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  family: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
  quietPlace: yup
    .string()
    .typeError("Selecione pelo menos uma opção.")
    .required("Selecione pelo menos uma opção."),
});
